import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import Subheader from "@components/Subheader/Subheader";
import BayHireEntryStateMessage from "@features/bay-hire/components/BayHireEntryStateMessage";
import { useBayHireContainer } from "@features/bay-hire/hooks/useBayHireContainer";
import PageLayout from "@layouts/PageLayout";
import { Navigate } from "react-router-dom";
import BayHireRequestList from "./components/BayHireRequestList/BayHireRequestList";

const BayHireContainer: React.FC = () => {
  const { dir, isOperationsUser, entryState, t, handleNewRequest } = useBayHireContainer();

  if (isOperationsUser) {
    return <Navigate to="operations" replace />;
  }

  // DFT-0033: page 11's design shows a top-right header "+ Bay Hire" button
  // (was a bordered-card "New Request" button below the header) - only on
  // the list view, matching Gatepass's create-button-in-Subheader convention.
  const showCreateButton = entryState === "allowed";

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId="bay-hire-landing-subheader"
        subtitle={t("bay-hire.subtitle")}
        title={
          showCreateButton ? (
            <div className="flex items-end justify-between w-full">
              <span>{t("bay-hire.title")}</span>
              <Button
                startIcon={<AddCircleOutlineIcon />}
                label={<span className="normal-case font-medium">{t("bay-hire.new-request")}</span>}
                testId="bay-hire-new-request-button"
                variant="contained"
                onClick={handleNewRequest}
              />
            </div>
          ) : (
            t("bay-hire.title")
          )
        }
      />
      <div data-testid="bay-hire-landing" className="mt-8 px-24">
        {entryState === "allowed" ? (
          <>
            <section
              aria-label="Allowed Bay Hire entry"
              aria-live="polite"
              className="mb-6"
              data-testid="bay-hire-entry-allowed"
            />
            <BayHireRequestList />
          </>
        ) : (
          <BayHireEntryStateMessage entryState={entryState} />
        )}
      </div>
    </PageLayout>
  );
};

export default BayHireContainer;
